// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__22SVc","checkboxCol":"Table_checkboxCol__Mj0uZ","emailCol":"Table_emailCol__2EBtI","actionCol":"Table_actionCol__1zhcg"};